import { getToken } from './auth';

const BASE = process.env.REACT_APP_API_URL;

const req = async (method, path, body) => {
  const token = getToken();
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `HTTP ${res.status}`);
  }
  return res.status === 204 ? null : res.json();
};

export const getGames = () => req('GET', '/games');
export const createGame = (data) => req('POST', '/games', data);
export const deleteGame = (gameId) => req('DELETE', `/games/${gameId}`);
export const toggleGameHidden = (gameId, hidden) => req('PATCH', `/games/${gameId}`, { hidden });

export const getEntries = (gameId) => req('GET', `/games/${gameId}/entries`);
export const enterLottery = (gameId, data) => req('POST', `/games/${gameId}/entries`, data);
export const deleteEntry = (gameId, employeeName) =>
  req('DELETE', `/games/${gameId}/entries/${encodeURIComponent(employeeName)}`);

export const runDraw = (gameId) => req('POST', `/games/${gameId}/draw`);
export const resetDraw = (gameId) => req('DELETE', `/games/${gameId}/draw`);

export const getEmployees = () => req('GET', '/employees');

export const getEmployeeEntries = (employeeName) => req('GET', `/employees/${encodeURIComponent(employeeName)}/entries`);
